import { Box, Flex, Image } from "@chakra-ui/react";
import { useGSAP } from '@gsap/react';
import { useRef } from 'react';
import gsap from 'gsap'
import { useTranslation } from '../../i18n/LanguageContext';

export default function Illustration() {
  const { t } = useTranslation();

  const containerRef = useRef();

  useGSAP(
    () => {
      gsap.from(".persona-card", {
        x: 60,
        opacity: 0,
        duration: 0.5,
        ease: "power2.inOut",
        stagger: 0.08
      });
    },
    { scope: containerRef }
);

  const cards = [
    { top: -25, right: 145, image: "/img/home/persona1.webp" },
    { top: 151, right: -194, image: "/img/home/persona2.webp" },
    { top: 328, right: 44, image: "/img/home/persona3.webp" },
    { top: 505, right: -133, image: "/img/home/persona4.webp" },
    { top: 682, right: 145, image: "/img/home/persona5.webp" },
  ];

  return (
    <Flex
      ref={containerRef}
      width={"100%"}
      flex={"1"}
      minW={"0"}
      h={"832px"}
      overflow={"hidden"}
      position={"relative"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Flex
        width={"100%"}
        height={"100%"}
        position={"relative"}
      >
        {cards.map((card, index) => (
          <Flex
            key={index}
            className="persona-card"
            position={"absolute"}
            top={`${card.top}px`}
            right={`${card.right}px`}
            w={"355px"}
            borderRadius={"100px"}
            px={"21px"}
            py={"18px"}
            bg={"#F1F1F1"}
            alignItems={"center"}
            gap={"22px"}
            boxShadow={"0px 12px 24px -8px rgba(12, 12, 13, 0.4)"}
          >
            <Image
              src={card.image}
              alt={`${t("personas.alt")} ${index + 1}`}
              boxSize={"58px"}
              borderRadius={"full"}
              objectFit={"cover"}
            />
            <Flex flexDirection={"column"} gap={"8px"}>
              <Box h={"36px"} w={"186px"} borderRadius={"40px"} bg={"#D9D9D9"} />
              <Box h={"30px"} w={"119px"} borderRadius={"40px"} bg={"#D9D9D9"} />
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}